export const LOGIN_OPTION: { [k: string]: string } = {
    EMAIL_LINK: "email_link",
    EMAIL_OTP: "email_otp",
    SOCIAL_LOGIN: "social_login",
    WALLET_LOGIN: "wallet_option"
}

export const STORAGE_KEYS = {
    LOGIN_TYPE: "lgn_option",
    ACCESS_TOKEN: "access_token",
    TEMP_ACCESS_TOKEN: "tfa_token",
    USER_META_INFO: "usr_meta",
    EMAIL_VERIFIED_LOCALLY: "email_verified_locally"
}

export const WALLET_PROVIDERS = {
    "METAMASK": "metaMask",
    "WALLET_CONNECT": "walletConnect",
    "FANTHOM": "fanthom"
}
export enum PositionStatus {
    ALL = 'ALL',
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'
}

export enum EmailVerificationState {
    LOADING = 0,
    SUCCESS = 1,
    ERROR = 2,
    WEB2_AUTH_ERROR = 3
}

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

// Market Sort Keys
export enum MarketSortKey {
    VOLUME_24H = 'VOLUME_24H',
    VOLUME_TOTAL = 'VOLUME_TOTAL',
    LIQUIDITY = 'LIQUIDITY',
    NEWEST = 'NEWEST',
    ENDING_SOON = 'ENDING_SOON',
    COMPETITIVE = 'COMPETITIVE',
    CLOSED_TIME = 'CLOSED_TIME'
}

// Market Frequency Filter
export enum MarketFrequency {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    ANNUAL = 'ANNUAL'
}

// Market Type Filter
export enum MarketType {
    ACTIVE = 'ACTIVE',
    RESOLVED = 'RESOLVED'
}

export const MARKET_SORT_KEY_MAP: Record<string, MarketSortKey> = {
    '24hr Volume': MarketSortKey.VOLUME_24H,
    'Total Volume': MarketSortKey.VOLUME_TOTAL,
    'Liquidity': MarketSortKey.LIQUIDITY,
    'Newest': MarketSortKey.NEWEST,
    'Ending Soon': MarketSortKey.ENDING_SOON,
    'Competitive': MarketSortKey.COMPETITIVE,
    'Closed Time': MarketSortKey.CLOSED_TIME
};

// Market Frequency Filter Mapping
export const MARKET_FREQUENCY_MAP: Record<string, MarketFrequency> = {
    'Daily': MarketFrequency.DAILY,
    'Weekly': MarketFrequency.WEEKLY,
    'Monthly': MarketFrequency.MONTHLY,
    'Annual': MarketFrequency.ANNUAL
};

// Market Type Filter Mapping
export const MARKET_TYPE_MAP: Record<string, MarketType> = {
    'Active': MarketType.ACTIVE,
    'Resolved': MarketType.RESOLVED
};

// Home Filter Dropdowns Configuration
export const HOME_FILTER_DROPDOWNS = [
    {
        key: 'volume' as const,
        selected: 'Newest',
        defaultValue: 'Newest',
        options: ['24hr Volume', 'Total Volume', 'Liquidity', 'Newest', 'Ending Soon', 'Competitive']
    },
    {
        key: 'frequency' as const,
        selected: 'All',
        defaultValue: 'All',
        options: ['All', 'Daily', 'Weekly', 'Monthly', 'Annual']
    },
    {
        key: 'status' as const,
        selected: 'Active',
        defaultValue: 'Active',
        options: ['Active', 'Resolved']
    }
];

export const POSITION_STATUS_OPTIONS = [
    { label: 'All', value: PositionStatus.ALL },
    { label: 'Open', value: PositionStatus.OPEN },
    { label: 'Closed', value: PositionStatus.CLOSED }
];

export const POSITION_SORT_OPTIONS = [
    { label: 'Desc', value: SortDirection.DESC },
    { label: 'Asc', value: SortDirection.ASC }
];

export const MIN_AMOUNT_OPTIONS = [
    { label: 'Min Amount', value: null },
    { label: '$10', value: 10 },
    { label: '$100', value: 100 },
    { label: '$1,000', value: 1000 },
    { label: '$10,000', value: 10000 },
    { label: '$100,000', value: 100000 }
];

export const SOCIAL_LOGIN_PROVIDERS = ['google', 'facebook', 'github', 'apple', 'discord'] as const;

export const WALLET_LOGIN_PROVIDERS = [WALLET_PROVIDERS.METAMASK, WALLET_PROVIDERS.WALLET_CONNECT, WALLET_PROVIDERS.FANTHOM] as const;

export const API_PATHS = {
    "AUTHETNICATE_USERS": "/api/v1/users/auth",
    "REQUEST_FOR_NONCE_BY_ADDRESS": "/api/v1/users/auth/request-nonce",
    "VERIFY_SIGNATURE": "/api/v1/users/auth/verify-signature",
    "UPDATE_EMAIL_ADDRESS": "/api/v1/users/email-update-request",
    "VERIFY_EMAIL_TOKEN": "/api/v1/users/verify-email-token",
    "UPDATE_USER_DETAILS": "/api/v1/users/update",
    "UPDAET_USER_NAME": "/api/v1/users/update-name",
    "VALIDATE_USER_NAME": "/api/v1/users/validate-username",
    "UPLOAD_PROFILE_IMAGE": "/api/v1/users/profile-image",
    "GET_USER_DETAILS": "/api/v1/users/profile",
    "ENABLE_USER_TRADING": "/api/v1/users/enable-trading",
    "ENABLE_2FA": "/api/v1/users/2fa-enable",
    "VERIFY_2FA": "/api/v1/users/2fa-verify",
    "REMOVE_2FA": "/api/v1/users/2fa-remove",
    "DISABLE_2FA": "/api/v1/users/2fa-disable",
    "UPDATE_EMAIL_ALERTS": "/api/v1/users/email-alerts",
    "USER_LOGOUT": "/api/v1/users/logout",
    "PLACE_ORDER": "/users/markets/{market_id}/orders",
    "GET_TOP_HOLDERS": "/markets/{market_id}/top-holders",
    // "ORDER_BOOK": "/markets/{market_id}/orderbook",
    "GET_MARKET_ORDERBOOK": "/markets/{market_id}/orderbook",
    "STREAM_MARKET_ORDERBOOK": "/markets/stream/{market_id}",
    "GET_MARKET_ACTIVITY": "/markets/activity",
    "GET_MARKET_POSITIONS": "/markets/{market_id}/outcomes/pnl",
    "GET_MARKET_PRICES_STREAM": "/markets/{market_id}/prices/stream",
    "TIME_IN_FORCE": "/api/v1/users/time-in-force",
    "GET_PRICE_HISTORY": "users/markets/{market_id}/price-history",
    "DEPOSIT_WALLET": "/users/wallets/deposit",
    "TRANSAK_SESSION": "/transak/session",
    "PRE_APPROVAL_EXECUTE": "/users/wallets/pre-approval-execute",
    "PREPARE_REDEEM": "/markets/{market_id}/redeem",
    "EXECUTE_REDEEM": "/markets/{market_id}/redeem/execute",

    "GET_CATEGORIES": "/api/v1/public/categories",
    "GET_MARKTEDATA": "/api/v1/public/markets",
    "GET_MARKET_COMMENT": "/api/v1/public/markets/comments",
    "POST_MARKET_COMMENT": "/api/v1/public/markets/comment",
    "GET_MARKET_OPEN_ORDERS": "/markets/user/open-orders",
    "GET_USER_ORDER_HISTORY": "/users/markets/orders/history",
    "GET_USER_PROFIT_SNAPSHOT": "/users/markets/profit/snapshot",
    "GET_USER_PROFIT_HISTORY": "/users/markets/profit/history",
    "GET_USER_POSITIONS": "/users/markets/positions",
    "EXPORT_USER_ORDER_HISTORY": "users/markets/orders/history/export",
    "GET_LEADERBOARD": "/leaderboard",
    "GET_LEADERBOARD_TOP_WINS": "/leaderboard/top-wins",
    "TOGGLE_MARKET_BOOKMARK": "/api/v1/public/markets/{market_id}/bookmark",
    "STREAM_PORTFOLIO_SUMMARY": "/users/wallets/portfolio-summary/stream",
    "STREAM_OUTCOME_POSITION": "/users/markets/outcomes/{outcome_id}/position/stream",
    "GET_MARKET_CONTEXT": "/markets/{market_id}/context",
    "GENERATE_MARKET_CONTEXT": "/markets/{market_id}/context",
    "GET_USER_TRADING_STATS": "/markets/user/{user_id}/trading-stats",
    "WITHDRAW_PREPARE": "/users/wallets/withdraw/prepare",
    "WITHDRAW_EXECUTE": "/users/wallets/withdraw"
}

export const HTTP_METHODS = {
    "GET": "GET",
    "PUT": "PUT",
    "POST": "POST",
    "PATCH": "PATCH",
    "DELETE": "DELETE"
}

export const TOAST_OPTIONS = {
    "SUCCESS": {
        "iconType": "svg",
        "icon": '<svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5"/></svg>',
        "iconLabel": "Check icon",
        "bgClass": "bg-neutral-primary-soft",
        "iconClass": "text-fg-success bg-success-soft",
        "progressBarColor": "bg-success"
    },
    "ERROR": {
        "iconType": "svg",
        "icon": '<svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6"/></svg>',
        "iconLabel": "Error icon",
        "bgClass": "bg-neutral-primary-soft",
        "iconClass": "text-fg-danger bg-danger-soft",
        "progressBarColor": "bg-danger"
    },
    "WARNING": {
        "iconType": "svg",
        "icon": '<svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
        "iconLabel": "Warning icon",
        "bgClass": "bg-neutral-primary-soft",
        "iconClass": "text-fg-warning bg-warning-soft",
        "progressBarColor": "bg-warning"
    },
    "INFO": {
        "iconType": "svg",
        "icon": "",
        "iconLabel": "Info icon",
        "bgClass": "bg-neutral-info-soft",
        "iconClass": "text-fg-info bg-info-soft",
        "progressBarColor": "bg-info"
    },
    "CLEAR": {}
}

export const ALLOWED_FILE_TYPES = {
    "PROFILE_IMAGE": ["jpg", "png", "jpeg"]
}

export const ALLOWED_FILE_SIZE = {
    "PROFILE_IMAGE": 1 // in megabytes
}

export const order_type = [{
    "label": "Buy",
    "value": "buy",
    "id": 1
}, {
    "label": "Sell",
    "value": "sell",
    "id": 2
}];

export const SOCKET_EVENTS = {
    NEW_COMMENT: "NEW_COMMENT",
    LIKE_ACTION: "LIKE_ACTION",
    COMMENT_LIKED: "COMMENT_LIKED",
    COMMENT_UNLIKED: "COMMENT_UNLIKED",
}

export const ERROR_MESSAGES: Record<string, string> = {
    OUTCOME_POSITION_NOT_ELIGIBLE_FOR_TRADE: 'Insufficient Balance to place order',
    WALLET_NOT_ELIGIBLE_FOR_TRADE: 'Insufficient Balance to place order',
    WALLET_NOT_PRE_APPROVED: 'Wallet is not approved for placing order'
};

export enum OrderSide {
    BUY = 0,
    SELL = 1
}

export enum MarketTab {
    COMMENTS = 'comments',
    HOLDERS = 'holders',
    POSITION = 'position',
    ACTIVITY = 'activity',
    ORDERBOOK = 'orderbook'

}

export enum PortfolioTab {
    POSITIONS = 'positions',
    ORDERS = 'orders',
    HISTORY = 'history'
}


export enum ResolutionState {
    MARKET_EXPIRED = 'MARKET_EXPIRED',
    WINNER_DECLARED = 'WINNER_DECLARED',
    SCHEDULED = 'SCHEDULED',
    ACTIVE = 'ACTIVE'
}

export enum ExpirationType {
    FIVE_MINUTES = "5m",
    ONE_HOUR = "1h",
    TWELVE_HOURS = "12h",
    TWENTY_FOUR_HOURS = "24h",
    END_OF_DAY = "End of Day"
}

export enum ActivityType {
    SOLD = 'sold',
    CLAIMED = 'claimed',
    DEPOSIT = 'deposit',
    DEPOSITED = 'deposited',
    LOST = 'lost',
    BOUGHT = 'bought',
    WITHDREW = 'withdrew'
}

export enum OrderHistoryType {
    ALL = 'All',
    BUY = 'Buy',
    TRADES = 'Trades',
    REDEEM = 'Redeem'
}

export enum OrderSort {
    MARKET = 'Market',
    FILL_QUANTITY = 'Filled Quantity',
    TOTAL_QUANTITY = 'Total Quantity',
    ORDER_DATE = 'Order Date',
    RESOLVING_SOONEST = 'Resolving Soonest'
}

export enum PositionSort {
    BET = 'BET',
    PROFIT_LOSS_PCT = 'PROFIT_LOSS_PCT',
    SHARES = 'SHARES',
    MARKET_NAME = 'MARKET_NAME',
    ENDING_SOON = 'ENDING_SOON',
    PAYOUT = 'PAYOUT',
    LATEST_PRICE = 'LATEST_PRICE',
    AVG_COST_PER_SHARE = 'AVG_COST_PER_SHARE'
}

export const POSITION_SORT_DROPDOWN_OPTIONS = [
    { label: 'Bet', value: PositionSort.BET },
    { label: 'Profit & Loss %', value: PositionSort.PROFIT_LOSS_PCT },
    { label: 'Shares', value: PositionSort.SHARES },
    { label: 'Alphabetically', value: PositionSort.MARKET_NAME },
    { label: 'Ending soon', value: PositionSort.ENDING_SOON },
    { label: 'Payout', value: PositionSort.PAYOUT },
    { label: 'Latest Price', value: PositionSort.LATEST_PRICE },
    { label: 'Average cost per share', value: PositionSort.AVG_COST_PER_SHARE }
];
